import React from 'react';
import { FileDown, CheckCircle, Clock, AlertTriangle, XCircle } from 'lucide-react';
import { accountantPortalAPI } from '../../services/api';

const eur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const fmt = (iso) => new Date(iso).toLocaleDateString('fr-FR');
const BADGE = {
  paid: ['bg-green-100 text-green-800', CheckCircle, (c) => `Payée le ${fmt(c.payment.paid_at)}${c.payment.reference ? ` · ${c.payment.reference}` : ''}`],
  rejected: ['bg-gray-200 text-gray-700', XCircle, () => 'Rejetée — correction attendue'],
  late: ['bg-red-100 text-red-800', AlertTriangle, (c) => `En retard (échéance ${fmt(c.due_date)})`],
  soon: ['bg-amber-100 text-amber-800', Clock, (c) => `À régler avant le ${fmt(c.due_date)}`],
  ok: ['bg-blue-50 text-blue-800', Clock, (c) => `À régler (échéance ${fmt(c.due_date)})`],
};

// Factures des centres de montage partenaires (achats de prestations) avec statut de règlement
const PortalCentreInvoices = ({ token, items }) => (
  <div className="rounded-xl border border-slate-200 bg-white overflow-hidden" data-testid="portal-centre-invoices">
    <div className="px-4 py-2 border-b border-slate-100"><p className="text-sm font-semibold text-slate-800">Factures des centres partenaires <span className="text-slate-400 font-normal">— prestations de montage sous-traitées ({items.length})</span></p></div>
    {items.length === 0 ? <p className="p-6 text-sm text-slate-400 text-center" data-testid="portal-centre-invoices-empty">Aucune facture de centre déposée.</p> : (
      <table className="w-full text-xs" data-testid="portal-centre-invoices-table">
        <thead className="bg-slate-50 text-slate-500 uppercase"><tr><th className="px-3 py-2 text-left">Centre</th><th className="px-3 py-2 text-left">Période</th><th className="px-3 py-2 text-left">N° facture</th><th className="px-3 py-2 text-left">Déposée le</th><th className="px-3 py-2 text-right">Montant TTC</th><th className="px-3 py-2 text-left">Règlement</th><th className="px-3 py-2 text-right">PDF</th></tr></thead>
        <tbody className="divide-y divide-slate-100">
          {items.map((c, i) => { const [cls, Icon, label] = BADGE[c.treasury_status] || BADGE.ok; return (
            <tr key={i} data-testid={`portal-centre-invoice-${i}`}>
              <td className="px-3 py-1.5 font-medium text-slate-800">{c.centre_name}</td>
              <td className="px-3 py-1.5 capitalize">{c.label}</td>
              <td className="px-3 py-1.5 font-mono">{c.invoice.invoice_number}</td>
              <td className="px-3 py-1.5">{fmt(c.invoice.uploaded_at)}</td>
              <td className="px-3 py-1.5 text-right font-semibold">{eur(c.invoice.amount)}</td>
              <td className="px-3 py-1.5"><span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-medium ${cls}`}><Icon size={11} /> {label(c)}</span></td>
              <td className="px-3 py-1.5 text-right"><a href={accountantPortalAPI.path(token, `files/${c.invoice.file_id}`)} className="inline-flex items-center gap-1 text-[#1e3a5f] underline" data-testid={`portal-centre-invoice-pdf-${i}`}><FileDown size={12} /> PDF</a></td>
            </tr>
          ); })}
        </tbody>
      </table>
    )}
  </div>
);

export default PortalCentreInvoices;
